﻿import React from 'react';
import { Link } from 'react-router-dom';
import { DateTimeDisplay } from '../../components/ui';
import { Breadcrumbs } from '../../components/ui';
import { useBreadcrumbs } from '../../hooks/useBreadcrumbs';

const NotFound: React.FC = () => {
  
    const breadcrumbs = useBreadcrumbs({
        currentPageTitle: '404 - Not Found',
    });

  return (
    <main>
      <div className="container">
        
            <section className='page'>
                <h2 className="heading__title">404!</h2>
                    <DateTimeDisplay />
            </section>

            <Breadcrumbs items={breadcrumbs} />

            <section className='page'>
                <div className='alarm-content pb-2'>
                
                    <h2>404 - Page Not Found</h2>
                    <p>The page you are looking for does not exist.</p>
                    <Link 
                        className="alarm-name-link"
                        to='/'
                    >
                    Go to Home
                    </Link>
                </div>
        </section>
      </div>
    </main>
  );
};

export default NotFound;
